// Mock data para la página web de pisos epóxicos

export const services = [
  {
    id: 1,
    title: "Industrial Epoxy Flooring",
    description: "High-strength solutions for warehouses, factories and industrial plants. Support heavy traffic and extreme conditions.",
    features: ["High strength", "Dust-proof", "Easy to clean", "Extreme durability", "Polished concrete"],
    image: "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0",
    pricePerM2: 35
  },
  {
    id: 2,
    title: "Commercial Epoxy Flooring",
    description: "Professional finishes for stores, restaurants, offices and commercial spaces. Aesthetics and functionality combined.",
    features: ["Glossy finish", "Variety of colors", "Traffic resistant", "Low maintenance", "Polished concrete"],
    image: "https://images.unsplash.com/photo-1704786450243-fe590b6bc9d3",
    pricePerM2: 28
  },
  {
    id: 3,
    title: "Residential Epoxy Flooring",
    description: "Transform garages, basements and residential spaces with premium long-lasting finishes using our exclusive Metallic System.",
    features: ["Custom designs", "Premium finish", "Stain resistant", "Increase value", "Metallic system"],
    image: "https://images.unsplash.com/photo-1766801075605-8c036a5c4ec3",
    pricePerM2: 25
  },
  {
    id: 4,
    title: "Parking Lots & Garages",
    description: "Long-lasting signage and finishes for public and private parking lots. Featuring Flake System and Quartz System for superior durability.",
    features: ["Signage included", "Oil resistant", "Non-slip", "Optimal drainage", "Flake & Quartz systems"],
    image: "https://images.unsplash.com/photo-1764836275138-175f0c674ddd",
    pricePerM2: 30
  },
  {
    id: 5,
    title: "Counter Tops",
    description: "Premium epoxy counter tops for kitchens. Durable, elegant and customizable designs that elevate your kitchen space.",
    features: ["Custom designs", "Heat resistant", "Easy maintenance", "Seamless finish", "Stain resistant"],
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba",
    pricePerM2: 45
  }
];

export const projects = [
  {
    id: 1,
    title: "Industrial Warehouse 2000m²",
    category: "Industrial",
    image: "https://images.unsplash.com/photo-1772300704502-410f0fbd43bb",
    description: "Complete installation in logistics warehouse"
  },
  {
    id: 2,
    title: "Shopping Mall - Loading Zone",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1772305595483-6b058aff40f9",
    description: "High-traffic epoxy application"
  },
  {
    id: 3,
    title: "Manufacturing Plant",
    category: "Industrial",
    image: "https://images.unsplash.com/photo-1772300164438-f73307d3b645",
    description: "Chemical-resistant epoxy floor"
  },
  {
    id: 4,
    title: "Corporate Parking Lot",
    category: "Commercial",
    image: "https://images.unsplash.com/photo-1704786450243-fe590b6bc9d3",
    description: "1500m² with complete signage"
  },
  {
    id: 5,
    title: "Premium Residential Garage",
    category: "Residential",
    image: "https://images.unsplash.com/photo-1766801075605-8c036a5c4ec3",
    description: "Premium finish with custom design"
  },
  {
    id: 6,
    title: "Logistics Warehouse",
    category: "Industrial",
    image: "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0",
    description: "High-durability floor system"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Thompson",
    company: "Northern Industries",
    role: "Operations Manager",
    text: "Excellent work on our 3000m² warehouse. The floor has perfectly withstood heavy traffic for 2 years. Very professional.",
    rating: 5,
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Michael"
  },
  {
    id: 2,
    name: "Sarah Campbell",
    company: "Plaza Shopping Center",
    role: "Administrator",
    text: "The parking lot transformation was incredible. They finished ahead of schedule and the result exceeded our expectations.",
    rating: 5,
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah"
  },
  {
    id: 3,
    name: "David Wilson",
    company: "Homeowner",
    role: "Residential Client",
    text: "My garage turned out spectacular. The team was very professional and the price very fair. I recommend them 100%.",
    rating: 5,
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=David"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does an epoxy floor last?",
    answer: "With proper maintenance, an epoxy floor can last between 10 and 20 years in residential applications, and 5 to 10 years in high-traffic industrial environments."
  },
  {
    id: 2,
    question: "How long does installation take?",
    answer: "It depends on the size of the area, but generally for residential spaces (100-200m²) it takes 2-3 days. Larger industrial projects can take 1-2 weeks."
  },
  {
    id: 3,
    question: "Is it resistant to chemicals and oils?",
    answer: "Yes, epoxy floors are highly resistant to most chemicals, oils, gasoline and solvents, making them ideal for garages and industrial environments."
  },
  {
    id: 4,
    question: "What maintenance does it require?",
    answer: "Maintenance is minimal. It only requires regular sweeping and occasional cleaning with water and mild detergent. No waxing or polishing needed."
  }
];

export const companyInfo = {
  name: "Monarca Epoxy Design",
  phone: "+1 416 708 4661",
  phoneAlt: "+1 647 403 5192",
  email: "info@monarcaepoxydesign.com",
  address: "34 Stanley Greene Blvd, North York, ON M3K 0A9",
  whatsapp: "14167084661",
  workingHours: "Mon - Fri: 8:00 AM - 6:00 PM, Sat: 9:00 AM - 2:00 PM"
};

// Mock form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Message sent successfully" });
    }, 1000);
  });
};

// Mock quote calculation
export const calculateQuote = (area, serviceType, additionalOptions) => {
  const basePrice = services.find(s => s.id === parseInt(serviceType))?.pricePerM2 || 25;
  let total = area * basePrice;
  
  // Additional options pricing
  if (additionalOptions.includes('sealant')) total += area * 5;
  if (additionalOptions.includes('design')) total += area * 8;
  if (additionalOptions.includes('antislip')) total += area * 3;
  
  return {
    basePrice,
    subtotal: area * basePrice,
    additionalCosts: total - (area * basePrice),
    total,
    area
  };
};

// Floor types comparison data for ROI calculator
export const floorTypes = [
  {
    id: 'epoxy',
    name: 'Epoxy Floor',
    initialCostPerM2: 30,
    maintenanceCostPerYear: 50,
    lifespan: 18,
    replacementCost: 0.7,
    benefits: [
      'Resistant to chemicals and oils',
      'Easy to clean',
      'Long-lasting glossy finish',
      'Optional non-slip',
      'No cracks or breaks'
    ]
  },
  {
    id: 'concrete',
    name: 'Polished Concrete',
    initialCostPerM2: 18,
    maintenanceCostPerYear: 350,
    lifespan: 7,
    replacementCost: 1.0,
    benefits: [
      'Low initial cost',
      'Industrial appearance'
    ]
  },
  {
    id: 'tiles',
    name: 'Ceramic Tiles',
    initialCostPerM2: 25,
    maintenanceCostPerYear: 200,
    lifespan: 10,
    replacementCost: 1.0,
    benefits: [
      'Variety of designs',
      'Water resistant'
    ]
  },
  {
    id: 'vinyl',
    name: 'Vinyl/PVC',
    initialCostPerM2: 15,
    maintenanceCostPerYear: 180,
    lifespan: 5,
    replacementCost: 1.0,
    benefits: [
      'Quick installation',
      'Very low initial cost'
    ]
  },
  {
    id: 'paint',
    name: 'Floor Paint',
    initialCostPerM2: 8,
    maintenanceCostPerYear: 280,
    lifespan: 3,
    replacementCost: 1.0,
    benefits: [
      'Most economical',
      'Quick application'
    ]
  }
];

// Calculate ROI comparison
export const calculateROI = (area, comparisonFloorType, years) => {
  const epoxy = floorTypes.find(f => f.id === 'epoxy');
  const comparison = floorTypes.find(f => f.id === comparisonFloorType) || floorTypes[1];
  
  // Epoxy costs
  const epoxyInitial = area * epoxy.initialCostPerM2;
  const epoxyMaintenanceTotal = epoxy.maintenanceCostPerYear * years;
  const epoxyReplacements = Math.floor(years / epoxy.lifespan);
  const epoxyReplacementCosts = epoxyReplacements * (epoxyInitial * epoxy.replacementCost);
  const epoxyTotalCost = epoxyInitial + epoxyMaintenanceTotal + epoxyReplacementCosts;
  
  // Comparison floor costs
  const comparisonInitial = area * comparison.initialCostPerM2;
  const comparisonMaintenanceTotal = comparison.maintenanceCostPerYear * years;
  const comparisonReplacements = Math.floor(years / comparison.lifespan);
  const comparisonReplacementCosts = comparisonReplacements * (comparisonInitial * comparison.replacementCost);
  const comparisonTotalCost = comparisonInitial + comparisonMaintenanceTotal + comparisonReplacementCosts;
  
  // Savings
  const totalSavings = comparisonTotalCost - epoxyTotalCost;
  const roi = ((totalSavings / epoxyInitial) * 100).toFixed(1);
  
  // Break-even point (years)
  let breakEvenYear = null;
  for (let year = 1; year <= years; year++) {
    const epoxyAtYear = epoxyInitial + (epoxy.maintenanceCostPerYear * year) + 
      (Math.floor(year / epoxy.lifespan) * (epoxyInitial * epoxy.replacementCost));
    const comparisonAtYear = comparisonInitial + (comparison.maintenanceCostPerYear * year) + 
      (Math.floor(year / comparison.lifespan) * (comparisonInitial * comparison.replacementCost));
    
    if (comparisonAtYear > epoxyAtYear && !breakEvenYear) {
      breakEvenYear = year;
    }
  }
  
  // Yearly breakdown for chart
  const yearlyData = [];
  for (let year = 0; year <= years; year++) {
    const epoxyAtYear = epoxyInitial + (epoxy.maintenanceCostPerYear * year) + 
      (Math.floor(year / epoxy.lifespan) * (epoxyInitial * epoxy.replacementCost));
    const comparisonAtYear = comparisonInitial + (comparison.maintenanceCostPerYear * year) + 
      (Math.floor(year / comparison.lifespan) * (comparisonInitial * comparison.replacementCost));
    
    yearlyData.push({
      year,
      epoxy: Math.round(epoxyAtYear),
      comparison: Math.round(comparisonAtYear),
      savings: Math.round(comparisonAtYear - epoxyAtYear)
    });
  }
  
  return {
    epoxy: {
      name: epoxy.name,
      initialCost: Math.round(epoxyInitial),
      maintenanceTotal: Math.round(epoxyMaintenanceTotal),
      replacements: epoxyReplacements,
      replacementCosts: Math.round(epoxyReplacementCosts),
      totalCost: Math.round(epoxyTotalCost),
      lifespan: epoxy.lifespan,
      benefits: epoxy.benefits
    },
    comparison: {
      name: comparison.name,
      initialCost: Math.round(comparisonInitial),
      maintenanceTotal: Math.round(comparisonMaintenanceTotal),
      replacements: comparisonReplacements,
      replacementCosts: Math.round(comparisonReplacementCosts),
      totalCost: Math.round(comparisonTotalCost),
      lifespan: comparison.lifespan,
      benefits: comparison.benefits
    },
    savings: {
      total: Math.round(totalSavings),
      percentage: totalSavings > 0 ? ((totalSavings / comparisonTotalCost) * 100).toFixed(1) : 0,
      roi: roi,
      breakEvenYear: breakEvenYear,
      perYear: Math.round(totalSavings / years)
    },
    yearlyData,
    area,
    years
  };
};
